import { Component } from 'react';
import styles from './TrainingVideo.scss';
import './external.scss';
import { DefaultPlayer as Video } from 'react-html5video';

export class TrainingVideo extends Component {
    render() {
        const { videoUrl } = this.props;

        return (
            <div className={styles.video} data-cy="TrainingVideo">
                <Video controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']} src={videoUrl} key={videoUrl} />
            </div>
        );
    }
}
